export default {
  mobile_app_average_order_value: {
    label: 'AOV przez aplikację',
  },
  mobile_app_gmv: {
    label: 'Sprzedaż przez aplikację',
  },
  mobile_app_gmv_percentage: {
    label: 'Przychody % przez aplikację',
  },
  mobile_app_downloads: {
    label: 'Pobrania',
  },
  mobile_app_orders_count: {
    label: 'Zamówienia przez aplikację',
  },
  name: {
    label: 'Restauracja',
  },
  mobile_app_released_at: {
    label: 'Data premiery',
  },
  title: 'Katalog restauracji',
};
